import { Address } from 'viem';
import { useReadContract, useConnection } from 'wagmi';

import { WHITELIST_ABI } from '@/app/shared/constants/web3/abi/WHITELIST_ABI';
import { getSharedChainContracts } from '@/app/shared/constants/web3/chainContracts';
import { ALLOWLIST_ADDRESS } from '@/app/shared/constants/web3/constants';

export const useIsWhitelisted = (address: Address | undefined) => {
    const { chainId } = useConnection();
    const allowlistAddress = getSharedChainContracts(chainId)?.ALLOWLIST ?? ALLOWLIST_ADDRESS;

    const { data, isLoading } = useReadContract({
        address: allowlistAddress,
        abi: WHITELIST_ABI,
        functionName: 'verifyAccount',
        args: address ? [address] : undefined,
        query: { enabled: !!address && !!allowlistAddress },
    });

    return {
        isWhitelisted: data ?? false,
        isLoading,
    };
};
// const { address } = useConnection();
// const { isWhitelisted, isLoading } = useIsWhitelisted(address);